document.addEventListener('DOMContentLoaded', function () {
  // Footer logo/text link
  const el = document.querySelector('.footer__block--text p.bold:first-child');

  if (el) {
    const link = document.createElement('a');
    link.href = '/';
    el.parentNode.insertBefore(link, el);
    link.appendChild(el);
  }

  // Home multi-column links
  const homeSection = document.querySelector(
    '#shopify-section-template--28397777977638__multi_column_EkgDk4'
  );

  if (homeSection) {
    homeSection.querySelectorAll('.multi-column__item').forEach(function (item) {
      const link = item.querySelector('a.button');
      if (!link) return;

      item.setAttribute('tabindex', '0');
      item.setAttribute('role', 'link');
      item.style.cursor = 'pointer';

      const go = () => window.location.href = link.href;

      item.addEventListener('click', function (e) {
        if (!e.target.closest('a')) go();
      });

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') go();
      });
    });
  }

  // How to Help columns
  document.querySelectorAll('.section').forEach(function (section) {
    const heading = section.querySelector('.section-header .h2');

    if (!heading || !heading.textContent.includes('How to Help')) return;

    section.querySelectorAll('.multi-column__item').forEach(function (item) {
      const link = item.querySelector('a.link');
      if (!link) return;

      item.style.cursor = 'pointer';

      item.addEventListener('click', function (e) {
        if (!e.target.closest('a')) {
          window.location.href = link.href;
        }
      });
    });
  });

  // Programs columns
  const programsSection = document.querySelector(
    '#shopify-section-template--28607118278950__multi_column_XGVQWw'
  );

  if (programsSection) {
    programsSection.querySelectorAll('.multi-column__item').forEach(function (item) {
      const link = item.querySelector('a.link');
      if (!link) return;

      item.style.cursor = 'pointer';

      item.addEventListener('click', function (e) {
        if (!e.target.closest('a')) {
          window.location.href = link.href;
        }
      });
    });
  }
});